interface PlaceholderPageProps {
  title: string;
  roadmapStage: string;
  description: string;
}

export function PlaceholderPage({ title, roadmapStage, description }: PlaceholderPageProps) {
  return (
    <div className="flex h-full flex-col items-start justify-center gap-3 rounded-lg border border-border bg-surface p-10">
      <span className="rounded-full bg-surface-2 px-3 py-1 font-mono text-xs uppercase tracking-wide text-accent">
        {roadmapStage}
      </span>
      <h1 className="text-2xl font-semibold text-text">{title}</h1>
      <p className="max-w-prose text-text-muted">{description}</p>
    </div>
  );
}
